import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn", "iosHint"]
  declare readonly btnTarget: HTMLElement
  declare readonly iosHintTarget: HTMLElement

  private deferredPrompt: any = null

  connect() {
    // Already installed as standalone — hide everything.
    if (window.matchMedia("(display-mode: standalone)").matches) {
      this.element.style.display = "none";
      return;
    }

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

    if (isIOS) {
      // iOS can't trigger the native prompt; show button that reveals manual instructions.
      this.btnTarget.style.display = "flex";
    } else {
      // Chrome/Edge/Android: wait for the browser's installability signal.
      window.addEventListener("beforeinstallprompt", (e: Event) => {
        e.preventDefault();
        this.deferredPrompt = e;
        this.btnTarget.style.display = "flex";
      });
    }
  }

  async install() {
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

    if (isIOS) {
      // Toggle the manual instruction hint below the button.
      const hint = this.iosHintTarget;
      hint.style.display = hint.style.display === "none" ? "block" : "none";
      return;
    }

    if (!this.deferredPrompt) return;
    this.deferredPrompt.prompt();
    const { outcome } = await this.deferredPrompt.userChoice;
    this.deferredPrompt = null;
    if (outcome === "accepted") {
      this.btnTarget.style.display = "none";
    }
  }
}
